<div class="content-wrapper container-xxl p-0" >
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <!-- errori dipendente non trovato -->
    <ngb-alert [type]="'danger'" [dismissible]="false" class="card w-100 mb-2" [ngClass]="openedErrorTab === 'danger2' ? 'active' : ''" *ngIf="fileContent.length > 0 && findErrors.length > 0">
      <h4 class="alert-heading py-1" (click)="openedErrorTab = openedErrorTab === 'danger2' ? '' : 'danger2'">{{ "EMPLOYEES_NOT_FOUND" | translate }} ({{ findErrors.length }})</h4>
      <section class="px-1" [ngClass]="openedErrorTab === 'danger2' ? 'alert-body' : 'd-none'">
        <ul class="mt-1">
          <li *ngFor="let fc of findErrors">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>
    <!-- errori update -->
    <ngb-alert [type]="'danger'" [dismissible]="false" class="card w-100 mb-2" [ngClass]="openedErrorTab === 'danger1' ? 'active' : ''" *ngIf="updateErrors.length > 0">
      <h4 class="alert-heading py-1" (click)="openedErrorTab = openedErrorTab === 'danger1' ? '' : 'danger1'">{{ "ERROR_UPDATING_TFR_FOR_THESE_EMPLOYEES" | translate }} ({{ updateErrors.length }})</h4>
      <section class="px-1" [ngClass]="openedErrorTab === 'danger1' ? 'alert-body' : 'd-none'">
        <ul class="mt-1">
          <li *ngFor="let fc of updateErrors">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>
    <!-- errori dipendente non trovato -->
    <div class="card" *ngIf="fileContent.length < 1">
      <div class="card-header">
        <h2 class="card-title">{{ 'SELECT_FILE_FOR_IMPORT_EMPLOYEES_TFR_AMOUNT' | translate }}</h2>
      </div>
      <div class="card-body row">
        <div class="col-lg-4">
          <fieldset>
            <div class="custom-file">
              <input class="custom-file-input" type="file" lang="it" id="resignation-upload" accept="application/vnd.sealed.xls" (change)="handlerChangeFileInput($event)" />
              <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card" *ngIf="fileContent.length < 1">
      <div class="card-header">
        <div>
          <h2 class="card-title">{{ 'SAVED_TFR_AMOUNTS' | translate }}</h2>
          <input type="search" [placeholder]="'SEARCH_BY_NAME' | translate" class="form-control mt-1" [(ngModel)]="filterKeyword" (keydown.enter)="searchSaved()" (change)="searchSaved()">
        </div>
      </div>
      <div class="card-body p-0 overflow-hidden">
        <ngx-datatable class="bootstrap core-bootstrap" [style.min-height.dvh]="filteredTFRList.length > 10 ? 70 : 10" columnMode="force" [rows]="filteredTFRList"
                       [headerHeight]="50" [scrollbarV]="true" [scrollbarH]="true" [rowHeight]="50" [sorts]="[{ prop: 'lastname', dir: 'asc' }]">
          <ngx-datatable-column [name]="'COMPLETE_NAME' | translate" prop="lastname" [sortable]="true" [width]="180">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="['/dashboard/user/profile', row.hash]">{{ row.lastname | titlecase }} {{ row.firstname | titlecase }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TFR_AMOUNT' | translate" prop="tfr_amount" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.tfr_amount | currency: 'EUR' }}</ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
    <div class="card" *ngIf="fileContent.length > 0">
      <div class="card-header">
        <h2 class="card-title">{{ 'PLEASE_VERIFY_DATA_BEFORE_IMPORT' | translate }}</h2>
        <div class="text-right" *ngIf="fileContent.length">
          <button class="btn btn-outline-secondary" type="button" (click)="fileContent = []; fileName = ''">{{ 'RESET' | translate }}</button>
          <button class="btn btn-outline-primary ml-2" type="button" (click)="save()">{{ 'SAVE' | translate }}</button>
        </div>
      </div>
      <div class="card-body p-0 overflow-hidden">
        <ngx-datatable class="bootstrap core-bootstrap" [style.min-height.dvh]="fileContent.length > 20 ? 60 : 30" columnMode="force" [rows]="fileContent"
                       [headerHeight]="50" [scrollbarV]="true" [scrollbarH]="true" [rowHeight]="50" [sorts]="[{ prop: 'lastname', dir: 'asc' }]">
          <ngx-datatable-column [name]="'COMPLETE_NAME' | translate" prop="complete_name" [sortable]="true" [width]="180">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="['/dashboard/user/profile', row.hash]">{{ row.complete_name | titlecase }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TFR_AMOUNT' | translate" prop="tfr" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.tfr | currency: 'EUR' }}</ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>